import styled from "styled-components";

export const PlacementCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 8px;
  .item-wrapper{ 
    border: 2px solid #ECEFF1;
    background-color: #F5FBFF;
    border-radius: 6px;
    padding: 16px 12px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px 16px;
    cursor: pointer;
    &.active{
    background-color:#1565D8;
    border: 2px solid #1565D8;
    .items {
  p {
  color: #ECEFF1;
  &:not(:first-child){
    color: #FFFFFF;
  }
}
}
      }
    }
    .items {
    display: flex;
    flex-direction: column;
    p {
    margin: 0px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #808183;
    &:not(:first-child){
      font-weight: 600;
      color: #4E5969;
    }
}
}
`;
